export * from './TimeClockMoveForwardIcon';
export * from './TimeClockMoveForwardIcon16Light';
export * from './TimeClockMoveForwardIcon16Regular';
export * from './TimeClockMoveForwardIcon16Solid';
export * from './TimeClockMoveForwardIcon20Light';
export * from './TimeClockMoveForwardIcon20Regular';
export * from './TimeClockMoveForwardIcon20Solid';
export * from './TimeClockMoveForwardIcon24Regular';
export * from './TimeClockMoveForwardIcon24Solid';
export * from './TimeClockMoveForwardIcon32Regular';
export * from './TimeClockMoveForwardIcon64Regular';
